import styled from "styled-components";

import { Color, ColorV2, Text } from "@adoptaunabuelo/react-components";
import media from "styled-media-query";
import Press, { Props as PressProps } from "../../assets/logo/Press";

const Container = styled.li`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 8px;
	border: 1px solid ${Color.line.soft};
	border-radius: 16px;
	padding: 24px;
	min-height: 200px;
	max-height: 200px;
	box-sizing: border-box;
	${media.lessThan("medium")`
		max-width: 100%;
		min-width: calc(100vw - 50px);
		padding: 20px 16px;
		scroll-snap-align: start;
	`}
`;
const PressText = styled(Text)`
	display: -webkit-box;
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
	margin: 0 !important;
	line-height: 24px !important;
	max-height: 96px;
`;
const LogoWrap = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	margin-top: auto;
	& > svg {
		height: 48px;
		width: auto;
	}
`;

const PressCell = (props: Props) => {
	return (
		<Container
			style={{
				maxWidth: `${100 / props.nCells}%`,
			}}
		>
			<PressText type="p" weight="medium">
				{props.press.text}
			</PressText>
			<LogoWrap>
				<Press type={props.press.logo} />
			</LogoWrap>
		</Container>
	);
};
export default PressCell;
export interface Props {
	nCells: number;
	press: {
		text: string;
		logo: PressProps["type"];
	};
}
